import { render, staticRenderFns } from "./ColorBar.vue?vue&type=template&id=7d64e49a&scoped=true"
import script from "./ColorBar.vue?vue&type=script&lang=js"
export * from "./ColorBar.vue?vue&type=script&lang=js"
import style0 from "./ColorBar.vue?vue&type=style&index=0&id=7d64e49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d64e49a",
  null
  
)

export default component.exports